import React, { Component } from 'react'
import PropType from 'prop-types'
import Dropdown from 'components/dropdown'
import MoneyInput from 'components/money-input'
import CtaButton from 'components/cta-button'
import { loanPurposeOptions } from 'components/dropdown/dropdown-options'
import { validateLoanAmount } from 'common/validations/loan-amount'
import { fireGtmEvent } from 'utils/gtm'
import { reduxForm } from 'redux-form'
import { extractNumber } from '@cred/shared/utils'
import PoweredBy from 'components/powered-by'
import styles from './styles.scss'

class PersonalLoanForm extends Component {
  static propTypes = {
    href: PropType.string.isRequired,
    widgetContext: PropType.object.isRequired,
    ctaText: PropType.string.isRequired,
  }

  constructor(props) {
    super(props)

    const { href } = this.props

    this.state = {
      url: href,
      loanAmount: null,
      loanPurpose: null,
      disabled: false,
    }
  }

  render() {
    const { ctaText } = this.props,
      { disabled, url } = this.state

    return (
      <>
        <section className={styles.form}>
          <div className="loan-amount mb-8">
            <MoneyInput
              name="loanAmount"
              label="Loan amount"
              placeholder="Loan amount"
              validate={[validateLoanAmount]}
              onChange={this.onLoanAmountChange}
              exposeValue
            />
          </div>
          <div className="loan-purpose mb-16">
            <Dropdown
              name="loanPurpose"
              label="Loan purpose"
              placeholder="Loan purpose"
              options={loanPurposeOptions}
              onChange={this.onLoanPurposeChange}
            />
          </div>
        </section>
        <section className={styles.submit}>
          <CtaButton
            href={url}
            onClick={this.onClick}
            blank
            fullWidth
            disabled={disabled}
          >
            {ctaText}
          </CtaButton>
          <PoweredBy className="mt-8" />
        </section>
      </>
    )
  }

  onLoanAmountChange = (evt) => {
    const { widgetContext, href } = this.props,
      { loanPurpose } = this.state,
      { value } = evt.target

    if (validateLoanAmount(value)) {
      this.setState({
        url: '',
        loanAmount: value,
        disabled: true,
      })
    } else {
      this.setState({
        url: loanPurpose ? `${href}&loanAmount=${extractNumber(value)}&loanPurpose=${loanPurpose}` : `${href}&loanAmount=${extractNumber(value)}`,
        disabled: false,
        loanAmount: value,
      })
    }

    fireGtmEvent('fieldChange', { ...widgetContext, loanAmount: value })
  }

  onLoanPurposeChange = (evt) => {
    const { widgetContext, href } = this.props,
      { loanAmount } = this.state,
      { value } = evt.target

    if (validateLoanAmount(loanAmount)) {
      this.setState({
        url: '',
        loanPurpose: value,
        disabled: true,
      })
    } else {
      this.setState({
        url: loanAmount ? `${href}&loanAmount=${extractNumber(loanAmount)}&loanPurpose=${value}` : `${href}&loanPurpose=${value}`,
        loanPurpose: value,
      })
    }

    fireGtmEvent('fieldChange', { ...widgetContext, loanPurpose: value })
  }


  onClick = () => {
    const { widgetContext } = this.props,
      { loanAmount, loanPurpose } = this.state

    if (!validateLoanAmount(loanAmount)) {
      fireGtmEvent('ctaClick', { ...widgetContext, loanPurpose, loanAmount })
    }
  }
}

export { PersonalLoanForm }

export default reduxForm({ form: 'personal-loan-form' })(PersonalLoanForm)
